module.exports = __webpack_public_path__ + "static/time-management-76d340992ef17531fe1a0a9b085cdba1.svg";